<template>
    <div v-if="!showMenu & showMenu != 'undefined'">
   <div class=" box-shadow">
       <div id="overlay"></div>
       <div class="" :class="$route.meta.BoxClass"><div class="content">The admission process involves filling out an application form <br/>
        <span>and being interviewed by the principal and teachers</span>
        <br/>
        <button>Our Services</button><button class="video">  <b-icon icon="camera-video-fill" class=" rounded text-center"></b-icon> Video tutorial</button>
       </div></div>

<!-- <div class="overlay-content">{{showTitle}}</div> -->

   </div>
   
    </div>
</template>

<script>
    export default {
        name:'Header',
        data(){
          return {
            title : this.showTitle,
           BoxClass: true
          }
        },
        props:['PageTitle'],
        computed:{
           showMenu(){
                 return this.$store.state.auth.Menuhide
            },
            showTitle(){
                  return this.$props.PageTitle
            }

        },
          mounted() {
        this.showMenu
        

        },
        
    }
</script>

<style scoped>
/* .banner{
    background-image: url(../assets/bg-body2.jpg);
    background-repeat: no-repeat;
    background-position: bottom;
    height: 600px;
    padding: 50px;
    text-align: center;
    color: #fff;
    background-size: cover;
    position: relative;
     box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
     margin-top: 40px;
} */

.box{
  /* Auto layout */
  z-index: 900;
/* display: flex; */
flex-direction: column;
align-items: flex-start;
padding: 30px 30px;
gap: 10px;

position: absolute;
width: 419.15px;
    height: 357px;
    left: 197px;
    top: 138px;

background: rgba(255, 255, 255, 0.85);
backdrop-filter: blur(5.5px);
/* Note: backdrop-filter has minimal browser support */
border-radius: 29px;
}
 .box .content{


font-family: 'Cabin';
font-style: normal;
font-weight: 700;
font-size: 35px;
line-height: 116%;
/* or 58px */

color: #072D6C;
text-align: left;
}
 .box .content span{

font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 147.5%;
/* or 24px */

color: #595566;
}
 .box .content button{
  
/* Button */

/* Auto layout */
display: flex;
flex-direction: row;
align-items: flex-start;
padding: 0px;
gap: 13px;
/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;
background: #072D6C;
border-radius: 42px;
font-family: 'Lato';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 100%;
padding: 10px 25px;
margin: 20px 10px;
float: left;
/* identical to box height, or 29px */

color: #FFFFFF;


}
 .box .content .video{

  box-sizing: border-box;

/* Auto layout */
display: flex;
flex-direction: row;
align-items: center;
padding: 8px 10px;
gap: 11px;

background: #FFFFFF;
border: 1px solid #EBEBEB;
border-radius: 42px;

/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;
font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 160%;
/* identical to box height, or 29px */

color: #353535;
margin-top: 20px;
float: left;

}

.box2{
  /* Auto layout */
  z-index: 900;
display: flex;
flex-direction: column;
align-items: flex-start;
padding: 30px 30px;
gap: 10px;

position: absolute;
width: 419.15px;
    height: 220px;
    left: 197px;
    top: 138px;

background: rgba(255, 255, 255, 0.85);
backdrop-filter: blur(5.5px);
/* Note: backdrop-filter has minimal browser support */
border-radius: 29px;
}
 .box2 .content{


font-family: 'Cabin';
font-style: normal;
font-weight: 700;
font-size: 20px;
line-height: 116%;
/* or 58px */

color: #072D6C;
text-align: left;
}
 .box2 .content span{

font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 147.5%;
/* or 24px */

color: #595566;
}
 .box2 .content button{
  
/* Button */

/* Auto layout */
display: none;
flex-direction: row;
align-items: flex-start;
padding: 0px;
gap: 13px;
/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;
background: #072D6C;
border-radius: 42px;
font-family: 'Lato';
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 100%;
padding: 10px 25px;
margin: 20px 10px;
float: left;
/* identical to box height, or 29px */

color: #FFFFFF;


}
 .box2 .content .video{

  box-sizing: border-box;

/* Auto layout */
display: flex;
flex-direction: row;
align-items: center;
padding: 8px 10px;
gap: 11px;

background: #FFFFFF;
border: 1px solid #EBEBEB;
border-radius: 42px;

/* Inside auto layout */
flex: none;
order: 1;
flex-grow: 0;
font-family: 'Lato';
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 160%;
/* identical to box height, or 29px */

color: #353535;
margin-top: 20px;
float: left;

}



#overlay {
position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0,0,0,0.1); /*dim the background*/
}

.overlay-content {
  position: relative;
  top: 18%; /* 25% from the top */
  width: 100%; /* 100% width */
  text-align: center; /* Centered text/links */
  margin-top: 30px; /* 30px top margin to avoid conflict with the close button on smaller screens */
  z-index: 333;
  font-size: 40px;
}

@media only screen and (max-width: 1000px) {

.banner {
  height: 400px !important;
}

.box{
  display: none;
}

.box2{
  display: none;
}

}
</style>